import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Screen } from '~/components/screens/dba'
import { site } from '~/config'

const Page = () => (
  <>
    <Seo title={`Operating Information | ${site.title}`} />
    <Screen />
  </>
)

export default Page
